// ##### 25-03-05 Komarov
import { SET_WHITELABEL_RES, SET_WHITELABEL_ERR } from '../constants';

const initState = {
  set: false,
  // ##### 24-03-14 Komarov
  isDemo: false,
  // ##### 25-02-12 Komarov
  company_cipher: '',
  data: null,
  error: null,
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case SET_WHITELABEL_RES:
      return {
        ...state,
        set: action.payload.set,
        // ##### 24-03-14 Komarov
        isDemo: action.payload.isDemo,
        // ##### 24-03-01 Komarov
        company_cipher: action.payload.company_cipher,
        data: action.payload.data,
      };

    case SET_WHITELABEL_ERR:
      return {
        ...state,
        error: (action.payload && action.payload.data) || action.error,
      };

    default:
      return state;
  }
};

export default reducer;
